import { Box, Typography } from "@mui/material";

// Banner component that displays a promotional message with a background image
const Banner = () => {
  return (
    <Box
      sx={{
        backgroundImage: "url('/assets/banner/banner2.jpg')", // Sets the background image
        backgroundSize: "cover", // Ensures the image covers the entire box
        backgroundPosition: "center", // Centers the image
        height: { xs: "100px", sm: "200px", md: "300px" }, // Responsive height settings
        display: "flex", // Enables flexbox for alignment
        alignItems: "center", // Centers items vertically
        justifyContent: "center", // Centers items horizontally
        flexDirection: "column", // Stacks text elements vertically
        color: "white", // Sets text color to white
      }}
    >
      {/* Main heading text */}
      <Typography
        sx={{
          fontSize: { xs: "20px", sm: "30px" },
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        Modern. Stylish. Timeless.
      </Typography>

      {/* Subheading text */}
      <Typography
        sx={{ fontSize: { xs: "18px", sm: "25px" }, fontWeight: "bold" }}
      >
        Find Your Perfect Look
      </Typography>
    </Box>
  );
};

export default Banner;
